module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"biography":"Биография","modal-biography":"Биография","all-biography":"Вся биография"},"en":{"biography":"Biography","modal-biography":"Biography of","all-biography":"All biography"}}')
  delete Component.options._Ctor
}
